var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMediumDiesel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 22,
    viewBox: "0 0 38 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 21.8148,
    rx: 4,
    fill: "#200F76"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 17H24V9.28587L27.2 5.85736H32.4C32.8243 5.85736 33.2313 6.03797 33.5314 6.35945C33.8314 6.68094 34 7.11697 34 7.57162V17Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5.00022C22.4667 4.99433 22.9279 5.10793 23.3454 5.33155C23.7628 5.55518 24.1244 5.88237 24.4 6.28591",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6001 7.57159H28.8001C28.3582 7.57159 28.0001 7.95534 28.0001 8.42872C28.0001 8.9021 28.3582 9.28585 28.8001 9.28585H31.6001C32.0419 9.28585 32.4001 8.9021 32.4001 8.42872C32.4001 7.95534 32.0419 7.57159 31.6001 7.57159Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26666 10.0527H17.0333",
    stroke: "white",
    strokeWidth: 1.1614,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3 14.6842H21V11.214C21 10.5726 20.48 10.0526 19.8386 10.0526H17.0333L14.7667 6H7.4L5.7 10.0526H5.1614C4.51998 10.0526 4 10.5726 4 11.214V14.6842H5.7",
    stroke: "white",
    strokeWidth: 1.1614,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09998 14.6842H15.3333",
    stroke: "white",
    strokeWidth: 1.1614,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40001 17C8.3389 17 9.10001 16.2224 9.10001 15.2631C9.10001 14.3039 8.3389 13.5263 7.40001 13.5263C6.46113 13.5263 5.70001 14.3039 5.70001 15.2631C5.70001 16.2224 6.46113 17 7.40001 17Z",
    stroke: "white",
    strokeWidth: 1.1614,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0334 17C17.9723 17 18.7334 16.2224 18.7334 15.2631C18.7334 14.3039 17.9723 13.5263 17.0334 13.5263C16.0945 13.5263 15.3334 14.3039 15.3334 15.2631C15.3334 16.2224 16.0945 17 17.0334 17Z",
    stroke: "white",
    strokeWidth: 1.1614,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3667 6V10.0526",
    stroke: "white",
    strokeWidth: 1.1614,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumDiesel);
export default __webpack_public_path__ + "static/media/mediumDiesel.a735c053fc0ac15248126a4726a121c5.svg";
export { ForwardRef as ReactComponent };